import React, {useState, useEffect} from "react";
import {getDataReviewOrtreetZip, likeService, upliftService, CommentToCommentModify} from "../services/rating";
import {Link, useNavigate} from "react-router-dom";
import moment from "moment";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {admin_role_id, super_admin_role_id} from "../constant";

import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import {sweetAlerts} from "../utils/sweet-alerts";
import CustomUserName from "../CustomComponents/CustomUserName";
import Typography from "@mui/material/Typography";
import {fTimeAgo} from "../utils/format-time";
import {Divider} from "antd";

import {Form, Formik} from "formik";

import {TextFieldForm} from "../CustomComponents/inputs";

import * as Yup from "yup";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import CustomUserProfile from "../CustomComponents/CustomUserProfile";
import IconButton from "@mui/material/IconButton";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import CardContent from "@mui/material/CardContent";
import ButtonGroup from "@mui/material/ButtonGroup";

const jobIssuesOptions = [
	{id: "unclear-expectations", label: "Unclear expectations"},
	{id: "scope-changed", label: "Scope changed mid-job"},
	{id: "payment-delayed", label: "Payment delayed"},
	{id: "verbal-aggression", label: "Verbal aggression"},
	{id: "threatened-review", label: "Threatened bad review"},
	{id: "access-issues", label: "Access issues (e.g. locked out, reschedules)"},
	{id: "micromanaged", label: "Client micromanaged"},
	{id: "safety-concerns", label: "Safety concerns"},
	{id: "poor-communication", label: "Poor communication"},
	{id: "other", label: "Other"},
];

const getCommentLabel = (item) => {
	const isSelf = item?.selfCreate == 1;
	const isHistoric = item?.is_historic == 1;

	if (isSelf && isHistoric) return "Your Old Comment";
	if (isSelf) return "Your Comment";
	if (isHistoric) return "Old Comment";
	return null;
};
const getRatingLabel = (item) => {
	const isSelf = item?.selfCreate == 1;
	const isHistoric = item?.is_historic == 1;

	if (isSelf && isHistoric) return "Your Old Rating";
	if (isSelf) return "Your Rating";
	if (isHistoric) return "Old Rating";
	return null;
};

const ReviewsListingPage = () => {
	const navigate = useNavigate();
	const [reviews, setReviews] = useState([]);
	const [loading, setLoading] = useState(true);
	const [flag, setFlag] = useState(true);
	const [activeReplyId, setActiveReplyId] = useState(null);
	const [searchedAddress, setSearchedAddress] = useState(""); // Track likes and uplifts for each review
	const [loadingButtons, setLoadingButtons] = useState({}); // Track loading state for individual buttons

	const [comments, setComments] = useState([]);
	const [allReviewComment, setAllReviewComment] = useState([]);
	const [ratingAvg, setRatingAvg] = useState(5);

	const [selfCreate, setSelfCreate] = useState(false);
	const [role, setRole] = useState(null);

	const [upliftString, setUpliftString] = useState(null);
	const [moderationError, setModerationError] = useState(null);

	const token = localStorage.getItem("auth_token");
	const is_login = localStorage.getItem("is_login");

	// Mock data for now - will be replaced with API call
	useEffect(() => {
		// Simulate API call
		setTimeout(async () => {
			try {
				const searchedAddress = localStorage.getItem("searchedAddress") || "Address not specified";

				setSearchedAddress(searchedAddress);

				const addresses_id = localStorage.getItem("reviews_addresses_id");
				const addresses_string = localStorage.getItem("searchedAddress");

				if (!addresses_id) {
					console.warn("No addresses_id found in localStorage");
					// Set default empty data
					setReviews([]);
					setComments([]);
					setLoading(false);
					return;
				}

				let response = await getDataReviewOrtreetZip(addresses_id, addresses_string);

				let transformedReviews = [];
				let transformedCommet = [];
				setUpliftString(null);
				if (response && response.status === true) {
					const reviewsData = response.data.ratings;
					// Transform the localStorage data to match the expected format
					transformedReviews = reviewsData
						? reviewsData.map((review, index) => {
								// Parse job_issues if it's a JSON string
								let issues = [""];
								try {
									if (review.job_issues && !Array.isArray(review.job_issues)) {
										const parsedIssues = JSON.parse(review.job_issues);
										if (Array.isArray(parsedIssues)) {
											// Convert issue IDs to human-readable labels
											issues = parsedIssues.map((issueId) => {
												const issueOption = jobIssuesOptions.find((option) => option.id === issueId);
												return issueOption ? issueOption.label : issueId;
											});
										} else {
											issues = [""];
										}
									} else if (Array.isArray(review.job_issues)) {
										issues = review?.job_issues || [""];
									} else {
										issues = [""];
									}
								} catch (e) {
									console.error("Error parsing job_issues:", e);
									issues = [""];
								}

								// Format the date
								const jobDate = review.job_date ? new Date(review.job_date) : new Date();
								const formattedDate = jobDate.toISOString().split("T")[0]; // YYYY-MM-DD format
								const fullFormattedDate = moment(formattedDate).format("MMM DD, YYYY");

								const likes = review?.likes || null;
								const trueCount = likes.filter((item) => item?.like == true).length;

								if (review?.selfCreate) {
									const today = new Date();
									const job_date = new Date(review?.job_date);

									// Days passed since job_date
									const diffTime = today - job_date; // in ms
									const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

									// Days left from 30-day window
									const daysLeft = 30 - diffDays;

									if (daysLeft > 1) {
										setUpliftString(`You can uplift a rating for this address in ${daysLeft} days.`);
									} else if (daysLeft === 1) {
										setUpliftString(`You can uplift a rating for this address in 1 day.`);
									}
									setSelfCreate(true);
								}

								return {
									id: review.rating_id || index + 1,
									selfLike: review?.selfLike,
									address: searchedAddress || "Address not specified",
									rating: review.stars || 0,
									reviewText: `Rating submitted on ${fullFormattedDate}. ${issues[0] !== "None" ? `Issues reported: ${issues.join(", ")}.` : "No issues reported."}`,
									reviewer: "Anonymous User", // Default since not provided in data
									role: "Contractor", // Default since not provided in data
									date: fullFormattedDate,
									category: "Construction", // Default since not provided in data
									issues: issues,
									avatar: "👷", // Default avatar
									likes: trueCount,
									upliftCount: review?.upliftCount,
									upliftByUser: review?.upliftByUser,
									selfCreate: review?.selfCreate,
									thisAddressAnyRating: review?.thisAddressAnyRating,
									type: "rating",
									is_historic: review?.is_historic || review?.is_historic == 1 || review?.is_historic != 0 ? true : false,
									user: review?.user,
									job_date: review.job_date,
									parent_uplift_id: review?.parent_uplift_id,
									uplift: review?.uplift,
								};
							})
						: [];

					const commetsData = response.data.comments;

					transformedCommet = commetsData
						? commetsData.map((review, index) => {
								// Format the date
								const jobDate = review.comment_date ? new Date(review.comment_date) : new Date();
								const formattedDate = jobDate.toISOString().split("T")[0]; // YYYY-MM-DD format
								const fullFormattedDate = moment(formattedDate).format("MMM DD, YYYY");
								const likes = review?.likes || null;
								const trueCount = likes.filter((item) => item?.like == true).length;

								console.log(review, "$$$$$$$");

								return {
									id: review.street_id || index + 1,
									selfLike: review?.selfLike,
									address: searchedAddress || "Address not specified",
									commentText: review?.description,
									commenter: review.client_name || "",
									role: "",
									date: fullFormattedDate,
									category: "",
									searchType: review.comment_type ? "Zipcode" : "Street",
									avatar: "👷",
									likes: trueCount,
									selfCreate: review?.selfCreate,
									type: "comment",
									is_historic: review?.is_historic || review?.is_historic == 1 || review?.is_historic != 0 ? true : false,
									user: review?.user,
									job_date: review.comment_date,
									street_id: review?.street_id,
									street_comments: review?.street_comments,
								};
							})
						: [];

					setReviews(transformedReviews);
					setComments(transformedCommet);
				} else {
					console.warn("API response status is false:", response);
					setReviews([]);
					setComments([]);
				}

				setLoading(false);
				setLoadingButtons({});
			} catch (error) {
				console.error("Error fetching reviews and comments:", error);
				setReviews([]);
				setComments([]);
				setLoading(false);
				setLoadingButtons({});
			}
		}, 10);
	}, [flag]);

	const getRatingClass = (rating) => {
		if (rating >= 4.5) return "rating-excellent";
		if (rating >= 3.5) return "rating-good";
		return "rating-poor";
	};

	const handleLikeReview = async (reviewId) => {
		setLoadingButtons((prev) => ({...prev, [`like-review-${reviewId}`]: true}));
		try {
			const response = await likeService({rating_id: reviewId});

			if (response && response.data.status) {
				// Refresh the data after successful like
				// You can call the same API again or update local state
				// For now, we'll update the local state
				setFlag(!flag);
			}
		} catch (error) {
			console.error("Error liking review:", error);
		} finally {
			setLoadingButtons((prev) => ({...prev, [`like-review-${reviewId}`]: false}));
		}
	};

	const handleLikeComment = async (commentId) => {
		if (is_login && token) {
			setLoadingButtons((prev) => ({...prev, [`like-comment-${commentId}`]: true}));
			try {
				const response = await likeService({street_id: commentId});

				if (response && response.data.status) {
					setFlag(!flag);
				}
			} catch (error) {
				console.error("Error liking comment:", error);
			} finally {
				setLoadingButtons((prev) => ({...prev, [`like-comment-${commentId}`]: false}));
			}
		} else {
			navigate("/login");
		}
	};

	const handleUplift = async (reviewId) => {
		if (is_login && token) {
			setLoadingButtons((prev) => ({...prev, [`uplift-${reviewId}`]: true}));
			try {
				const response = await upliftService({rating_id: reviewId});

				if (response && response.data.status) {
					setFlag(!flag);

					sweetAlerts("success", response?.data?.message);
				}
			} catch (error) {
				console.error("Error liking comment:", error);
			} finally {
				setLoadingButtons((prev) => ({...prev, [`uplift-${reviewId}`]: false}));
			}
		} else {
			navigate("/login");
		}
	};

	const commentToCommentAction = async (data) => {
		if (is_login && token) {
			setLoadingButtons((prev) => ({...prev, [`comment-${data?.street_id}`]: true}));
			try {
				const response = await CommentToCommentModify(data);

				if (response && response.data.status) {
					setFlag(!flag);
					sweetAlerts("success", response?.data?.message);
					setModerationError(null);
				} else {
					if (response.data.reasons) {
						setModerationError({
							street_id: data?.street_id,
							message: response.message || "Your comment contains restricted content and cannot be published.",
							reasons: response.data.reasons || [],
							policy_tags: response.data.policy_tags || [],
						});
					} else {
						sweetAlerts("error", response?.message);
					}
				}
			} catch (error) {
				sweetAlerts("error", error?.message);
				setModerationError(null);
				console.error("Error liking comment:", error);
			} finally {
				setLoadingButtons((prev) => ({...prev, [`comment-${data?.street_id}`]: false}));
			}
		} else {
			navigate("/login");
		}
	};

	useEffect(() => {
		const role = localStorage.getItem("role");
		setRole(role);
	}, []);

	useEffect(() => {
		reviews.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
		comments.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

		const merged = is_login && token ? [...reviews, ...comments] : [...comments];

		const newReview = reviews?.filter((item) => !item?.is_historic);

		const dataRating = newReview?.length > 0 ? (newReview.reduce((sum, job) => sum + job.rating, 0) / newReview.length).toFixed(1) : 5;

		setRatingAvg(parseFloat(dataRating));

		setRatingAvg(dataRating);

		const filterList = reviews?.filter((item) => !item?.parent_uplift_id && item?.uplift === false);

		const mergedUp = is_login && token ? [...filterList, ...comments] : [...comments];

		setAllReviewComment(mergedUp);
	}, [comments, reviews]);

	if (loading) {
		return (
			<div className="container mt-5">
				<div className="text-center">
					<div className="spinner-border" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<p className="mt-3">Loading reviews...</p>
				</div>
			</div>
		);
	}

	return (
		<div className="">
			<Navbar />
			<div className="container">
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						gap: 1,
					}}>
					<Link to="/">
						<IconButton>
							<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 512 512">
								<rect width="512" height="512" fill="none" />
								<path
									fill="#21C847"
									d="M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48S48 141.13 48 256m212.65-91.36a16 16 0 0 1 .09 22.63L208.42 240H342a16 16 0 0 1 0 32H208.42l52.32 52.73A16 16 0 1 1 238 347.27l-79.39-80a16 16 0 0 1 0-22.54l79.39-80a16 16 0 0 1 22.65-.09"
								/>
							</svg>
						</IconButton>
					</Link>

					<Typography
						variant="h3"
						sx={{
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							fontWeight: 400,
						}}>
						{searchedAddress}
					</Typography>
				</Box>

				<Typography
					variant="h5"
					sx={{
						fontWeight: 400,
						color: "#898989",
						mt: 1,
					}}>
					Browse through all contractor reviews, ratings, and comments for this address
				</Typography>

				{allReviewComment.length === 0 && (
					<div className="mb-3 pb-0">
						<Alert severity="info">For privacy, one rating doesn’t change the default 5-stars until second rating appears.</Alert>
					</div>
				)}

				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						gap: 1,
						backgroundColor: "#F8F9FA",
						p: 2,
						borderRadius: 1,
						my: 2,
					}}>
					<h1 style={{margin: 0, fontSize: "clamp(1.2rem, 3vw, 2rem)"}}>{ratingAvg || 5}</h1>
					<Rating value={ratingAvg} precision={0.5} name="size-large" defaultValue={2} size="large" readOnly sx={{fontSize: {xs: "1.2rem", md: "2rem"}}} />
					<Box sx={{display: "flex", flexWrap: "wrap", gap: {xs: 0.5, md: 1}, alignItems: "center"}}>
						<span className="text-muted" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
							({reviews?.filter((item) => !item?.is_historic)?.length || 0}) reviews
						</span>
						<span className="text-muted" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
							({comments?.filter((item) => !item?.is_historic)?.length || 0}) comments
						</span>
						<span className="text-muted d-none d-md-inline" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
							{" "}
							|{" "}
						</span>
						<span className="text-muted" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
							({reviews?.filter((item) => item?.is_historic || item?.is_historic == 1)?.length || 0}) Old reviews
						</span>
						<span className="text-muted" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
							({comments?.filter((item) => item?.is_historic || item?.is_historic == 1)?.length || 0}) Old comments
						</span>
					</Box>
				</Box>
			</div>

			<div className="container">
				{allReviewComment.length === 0 && (
					<div className="text-center py-5">
						<div className="mb-3">
							<svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-muted">
								<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</div>
						<h4>No Reviews & Comments found</h4>
						<p className="text-muted">No reviews & comments match the selected filter criteria.</p>
					</div>
				)}
				{allReviewComment?.length > 0 &&
					allReviewComment?.map((item, key) => {
						if (item?.type === "rating") {
							const label = getRatingLabel(item);

							const isSelf = item?.selfCreate == 1;
							const isHistoric = item?.is_historic == 1;
							const hasUplifted = item?.upliftByUser;
							const isBlockedByRule = Boolean(upliftString);

							// 🔒 FINAL DISABLE CONDITION
							const isUpliftDisabled = isSelf || isHistoric || (!hasUplifted && isBlockedByRule);
							return (
								<Card
									sx={{
										borderRadius: 1,
										border: "1px solid #ddd",
										mb: 1,
									}}>
									{/* Header */}
									<Stack direction="row" alignItems="center" justifyContent="space-between" sx={{borderBottom: "1px solid #ddd", p: 1}}>
										<Stack direction="row" alignItems="center" spacing={1}>
											<CustomUserProfile user={item?.user} sx={{fontWeight: 900}} code />
											<Box>
												<Stack direction="row" alignItems="center" spacing={0.5}>
													<CustomUserName user={item?.user} sx={{fontWeight: 900, fontSize: {xs: "0.85rem", md: "1rem"}}} code />
												</Stack>
												<Typography fontSize={12} color="text.secondary">
													{fTimeAgo(item?.job_date)}
												</Typography>
											</Box>
										</Stack>

										<Stack direction="row" alignItems="center" spacing={0.5}>
											<Rating value={item.rating} name="size-large" size="small" readOnly />
											<Typography variant="body1" fontWeight={500}>
												{item.rating}/5
											</Typography>
										</Stack>
									</Stack>

									{/* Rating Title */}
									{label && (
										<Stack
											direction="row"
											justifyContent="space-between"
											sx={{
												borderBottom: "1px solid #ddd",
												borderRight: "1px solid #ddd",
												borderEndEndRadius: 20,
												p: 0.2,
												display: "inline-block",
												px: 2,
											}}>
											<Stack direction="row" alignItems="center" spacing={1}>
												<Typography fontWeight={600} sx={{color: "#FFC107", fontSize: 18}}>
													★
												</Typography>
												<Typography fontWeight={600}>{label}</Typography>
											</Stack>
										</Stack>
									)}

									{/* Issue Chips */}
									<Box sx={{p: 1}}>
										<Typography fontWeight={600}>Issues:</Typography>
										<Box mt={1} display="flex" gap={1} flexWrap="wrap">
											{item.issues.map((issue, index) => (
												<Chip
													key={index}
													label={issue}
													variant="outlined"
													sx={{
														borderColor: "#F2C200",
														background: "#FFD70059",
														color: "#000",
														fontWeight: 500,
														borderRadius: "20px",
														px: 1,
													}}
												/>
											))}
										</Box>

										{/* Footer */}
										<Stack direction="row" justifyContent="space-between" alignItems="center" mt={3}>
											<Typography color="text.secondary" variant="body2" fontWeight={500}>
												{item?.date}
											</Typography>

											{role !== super_admin_role_id && role !== admin_role_id && (
												<Stack
													direction="row"
													spacing={0}
													alignItems="center"
													sx={{
														border: "1px solid #ddd",
														borderRadius: "30px",
													}}>
													<Tooltip
														placement="top"
														title={
															item?.is_historic ? "You cannot Like/Unlike Old Review rating" : item?.selfCreate ? "You cannot like your own rating" : item?.selfLike?.like ? "Unlike this rating" : "Like this rating"
														}
														arrow>
														<Button
															sx={{
																display: "flex",
																alignItems: "center",
																borderRight: "1px solid #ddd",
																borderRadius: "30px",
																gap: 0.5,
															}}
															disabled={item?.is_historic ? true : item?.selfCreate ? true : item?.selfLike?.like ? false : false}
															onClick={() => !item?.selfCreate && !item?.is_historic && handleLikeReview(item.id)}>
															<div className={item?.selfLike?.like ? "bi-hand-thumbs-up-fill" : "bi-hand-thumbs-up"} style={{fontSize: "clamp(12px, 2vw, 14px)"}} />
															<Typography fontWeight={500}>{item?.likes || 0}</Typography>
														</Button>
													</Tooltip>

													<Tooltip
														placement="top"
														title={
															item?.is_historic
																? "You cannot uplift Old rating"
																: item?.selfCreate
																	? "You cannot uplift your own rating"
																	: upliftString
																		? upliftString
																		: item?.upliftByUser
																			? "Remove Uplift this rating"
																			: "Uplift this rating"
														}
														arrow>
														<Button
															disabled={isUpliftDisabled}
															sx={{
																display: "flex",
																alignItems: "center",
																borderRadius: "30px",
																px: 1.3,
																py: 0.5,
																gap: 0.5,
																color: hasUplifted ? "#28A745" : "#000",
																"&.Mui-disabled": {
																	color: "#bbb",
																	cursor: "not-allowed",
																},
															}}
															onClick={() => (item?.selfCreate ? "" : item?.upliftByUser ? handleUplift(item.id) : upliftString ? "" : item?.is_historic ? "" : handleUplift(item.id))}>
															<svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{width: "clamp(12px, 2vw, 16px)", height: "clamp(12px, 2vw, 16px)"}}>
																<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
															</svg>
															{item?.upliftByUser ? "Uplifted" : "Uplift"}
														</Button>
													</Tooltip>
												</Stack>
											)}
										</Stack>
									</Box>
								</Card>
							);
						}

						if (item?.type === "comment") {
							const label = getCommentLabel(item);
							// const [replay, setReplay] = useState(false);
							return (
								<Card
									sx={{
										border: "1px solid #dcdcdc",
										borderRadius: 1,
										mb: 1,
									}}>
									{/* HEADER */}
									<Box sx={{p: 1, borderBottom: "1px solid #dcdcdc"}}>
										<Stack direction="row" justifyContent="space-between" alignItems="center">
											<Stack direction="row" spacing={1.5}>
												<CustomUserProfile user={item?.user} sx={{fontWeight: 900}} />
												<Box>
													<CustomUserName user={item?.user} sx={{fontWeight: 900, fontSize: {xs: "0.85rem", md: "1rem"}}} />
													<Typography fontSize={12} color="text.secondary">
														{fTimeAgo(item?.job_date)}
													</Typography>
												</Box>
											</Stack>

											<Stack alignItems="center">
												{item.searchType === "Street" ? (
													<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24">
														<rect width="24" height="24" fill="none" />
														<path fill="#000" d="M12 0a1 1 0 0 1 1 1v2h5v6h-5v3h5l4 3l-4 3h-5v5a1 1 0 1 1-2 0v-5H6v-6h5V9H6L2 6l4-3h5V1a1 1 0 0 1 1-1" />
													</svg>
												) : (
													<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 256 256">
														<rect width="256" height="256" fill="none" />
														<path fill="#000" d="M136 127.42V232a8 8 0 0 1-16 0V127.42a56 56 0 1 1 16 0" />
													</svg>
												)}
												<Typography fontSize={12} fontWeight={600}>
													{item.searchType}
												</Typography>
											</Stack>
										</Stack>
									</Box>

									{label && (
										<Stack
											direction="row"
											justifyContent="space-between"
											sx={{
												borderBottom: "1px solid #ddd",
												borderRight: "1px solid #ddd",
												borderEndEndRadius: 20,
												p: 0.2,
												display: "inline-block",
												px: 2,
											}}>
											<Stack direction="row" alignItems="center" spacing={1}>
												<Typography fontWeight={600}>{label}</Typography>
											</Stack>
										</Stack>
									)}

									{/* COMMENT */}
									<Box pb={1} px={1}>
										<Typography fontSize={16} lineHeight={1.6}>
											“{item.commentText}”
										</Typography>
									</Box>
									{/* 
									<Stack direction="row" justifyContent="space-between" alignItems="center" px={1} pb={1}>
										<Typography fontSize={13} color="text.secondary">
											{item?.date}
										</Typography>

										{role !== super_admin_role_id && role !== admin_role_id && (
											<Stack
												direction="row"
												spacing={0}
												alignItems="center"
												sx={{
													border: "1px solid #ddd",
													borderRadius: "30px",
												}}>
												<Tooltip
													placement="top"
													arrow
													title={
														item?.selfCreate ? "You cannot Like/Unlike your own comment" : item?.is_historic ? "You cannot like Old comment" : item?.selfLike?.like ? "Unlike this comment" : "Like this comment"
													}>
													<Button
														size="small"
														sx={{
															display: "flex",
															alignItems: "center",
															borderRight: "1px solid #ddd",
															borderRadius: "30px",
															gap: 0.5,
														}}
														startIcon={<div className={item?.selfLike?.like ? "bi-hand-thumbs-up-fill" : "bi-hand-thumbs-up"} style={{fontSize: "clamp(12px, 2vw, 14px)"}} />}
														disabled={item?.selfCreate || item?.is_historic}
														onClick={() => !item?.selfCreate && !item?.is_historic && handleLikeComment(item.id)}>
														{item?.likes || 0}
													</Button>
												</Tooltip>
												<Tooltip placement="top" arrow>
													<Button
														size="small"
														disabled={item?.is_historic}
														sx={{
															display: "flex",
															alignItems: "center",
															borderRadius: "30px",
															px: 1.3,
															py: 0.5,
															gap: 0.5,
															color: item?.is_historic ? "#28A745" : "#000",
															"&.Mui-disabled": {
																color: "#bbb",
																cursor: "not-allowed",
															},
														}}
														onClick={() => setActiveReplyId(activeReplyId === item.street_id ? null : item.street_id)}>
														Reply
													</Button>
												</Tooltip>
											</Stack>
										)}
									</Stack> */}

									{activeReplyId !== item.street_id && role !== super_admin_role_id && role !== admin_role_id && item?.is_historic != 1 && (
										<Stack direction="row" justifyContent="space-between" alignItems="center" px={1} pb={1}>
											<Typography fontSize={13} color="text.secondary">
												{item?.date}
											</Typography>

											{role !== super_admin_role_id && role !== admin_role_id && (
												<Stack
													direction="row"
													spacing={0}
													alignItems="center"
													sx={{
														border: "1px solid #ddd",
														borderRadius: "30px",
													}}>
													<Tooltip
														placement="top"
														arrow
														title={
															item?.selfCreate ? "You cannot Like/Unlike your own comment" : item?.is_historic ? "You cannot like Old comment" : item?.selfLike?.like ? "Unlike this comment" : "Like this comment"
														}>
														<Button
															size="small"
															sx={{
																display: "flex",
																alignItems: "center",
																borderRight: "1px solid #ddd",
																borderRadius: "30px",
																gap: 0.5,
															}}
															startIcon={<div className={item?.selfLike?.like ? "bi-hand-thumbs-up-fill" : "bi-hand-thumbs-up"} style={{fontSize: "clamp(12px, 2vw, 14px)"}} />}
															disabled={item?.selfCreate || item?.is_historic}
															onClick={() => !item?.selfCreate && !item?.is_historic && handleLikeComment(item.id)}>
															{item?.likes || 0}
														</Button>
													</Tooltip>
													<Tooltip placement="top" arrow>
														<Button
															size="small"
															disabled={item?.is_historic}
															sx={{
																display: "flex",
																alignItems: "center",
																borderRadius: "30px",
																px: 1.3,
																py: 0.5,
																gap: 0.5,
																color: item?.is_historic ? "#28A745" : "#000",
																"&.Mui-disabled": {
																	color: "#bbb",
																	cursor: "not-allowed",
																},
															}}
															onClick={() => setActiveReplyId(activeReplyId === item.street_id ? null : item.street_id)}>
															Reply
														</Button>
													</Tooltip>
												</Stack>
											)}
										</Stack>
									)}

									{activeReplyId === item.street_id && role !== super_admin_role_id && role !== admin_role_id && item?.is_historic != 1 && (
										<Formik
											enableReinitialize
											initialValues={{
												street_id: item?.street_id,
												comment_text: "",
											}}
											validationSchema={Yup.object().shape({
												comment_text: Yup.string().trim().required("Comment is required."),
											})}
											onSubmit={async (values, {resetForm}) => {
												setModerationError();
												await commentToCommentAction(values);
												resetForm();
												setActiveReplyId(null);
											}}>
											{(props) => {
												const {handleSubmit} = props;
												return (
													<Form noValidate>
														{moderationError && item?.street_id == moderationError?.street_id && (
															<div
																className="moderation-error-alert mx-3"
																style={{
																	backgroundColor: "#fee",
																	border: "1px solid #fcc",
																	borderRadius: "4px",
																	padding: "12px",
																	marginBottom: "10px",
																	color: "#c33",
																}}>
																<strong style={{display: "block", marginBottom: "8px"}}>{moderationError.message}</strong>
																{moderationError.reasons && moderationError.reasons.length > 0 && (
																	<div style={{fontSize: "14px", marginTop: "8px"}}>
																		<strong>Reasons:</strong>
																		<ul style={{margin: "4px 0 0 20px", padding: 0}}>
																			{moderationError.reasons.map((reason, idx) => (
																				<li key={idx}>{reason}</li>
																			))}
																		</ul>
																	</div>
																)}
																{moderationError.policy_tags && moderationError.policy_tags.length > 0 && (
																	<div style={{fontSize: "12px", marginTop: "8px", color: "#999"}}>Tags: {moderationError.policy_tags.join(", ")}</div>
																)}
															</div>
														)}

														<Stack direction="row" gap={1.5} px={1} pb={1} sx={{alignItems: "center"}}>
															<TextFieldForm placeholder="Write a comment ..." required={false} formik={props} field="comment_text" rows={2} disabled={loadingButtons[`comment-${item?.street_id}`]} />
															<Box>
																<Stack
																	direction="row"
																	spacing={0}
																	alignItems="center"
																	sx={{
																		border: "1px solid #ddd",
																		borderRadius: "30px",
																	}}>
																	<Tooltip placement="top" arrow>
																		<Button
																			size="small"
																			disabled={loadingButtons[`comment-${item?.street_id}`]}
																			startIcon={loadingButtons[`comment-${item?.street_id}`] ? <CircularProgress size={16} color="inherit" /> : null}
																			onClick={handleSubmit}
																			sx={{
																				display: "flex",
																				alignItems: "center",
																				borderRadius: "30px",
																				px: 1.3,
																				py: 0.5,
																				gap: 0.5,
																				color: item?.is_historic ? "#28A745" : "#000",
																				"&.Mui-disabled": {
																					color: "#bbb",
																					cursor: "not-allowed",
																				},
																			}}>
																			{loadingButtons[`comment-${item?.street_id}`] ? "Replying..." : "Reply"}
																		</Button>
																	</Tooltip>

																	<Button
																		size="small"
																		disabled={item?.is_historic}
																		sx={{
																			display: "flex",
																			alignItems: "center",
																			borderRadius: "30px",
																			px: 1.3,
																			py: 0.5,
																			gap: 0.5,
																			color: "#d61212",
																			"&.Mui-disabled": {
																				color: "#bbb",
																				cursor: "not-allowed",
																			},
																		}}
																		onClick={() => setActiveReplyId(activeReplyId === item.street_id ? null : item.street_id)}>
																		Cancel
																	</Button>
																</Stack>
															</Box>
														</Stack>
													</Form>
												);
											}}
										</Formik>
									)}

									{/* REPLIES */}
									{item?.street_comments?.length > 0 && (
										<Box px={1} pb={2} sx={{borderTop: "1px solid #DDD"}}>
											{item.street_comments.map((reply) => (
												<Stack key={reply.id} spacing={1} mt={1.5} ml={3} alignItems="flex-start">
													<Stack direction="row" spacing={1.5}>
														<CustomUserProfile user={reply?.user} width={32} sx={{fontSize: {xs: 11, md: 13}}} />
														<Box>
															<CustomUserName user={reply?.user} sx={{fontWeight: 900, fontSize: {xs: 12, md: 14}}} />
															<Typography fontSize={12} color="text.secondary">
																{fTimeAgo(reply?.createdAt)}
															</Typography>

															<Box>
																<Typography fontSize={13}> “{reply?.description}”</Typography>
															</Box>
														</Box>
													</Stack>
												</Stack>
											))}
										</Box>
									)}
								</Card>
							);
						}
					})}

				<Stack direction="row" justifyContent="center" spacing={0.5} my={2}>
					<Button
						variant="contained"
						onClick={() => {
							navigate("/", {state: {address: searchedAddress, from: "review"}});
						}}
						fullWidth
						sx={{gap: 1, background: "#00FF5E1C", color: "#22C55E", border: "1px solid #22C55E"}}>
						<Typography fontWeight={600} sx={{color: "#FFC107", fontSize: 18}}>
							★
						</Typography>
						Add Your Review
					</Button>
					<Button
						variant="contained"
						onClick={() => {
							navigate("/", {state: {address: searchedAddress, from: "street"}});
						}}
						fullWidth
						sx={{gap: 1, background: "#F8F9FA", color: "#605F5F", border: "1px solid #d8d6d6"}}>
						<Typography fontWeight={600} sx={{color: "#FFC107", fontSize: 18}}>
							<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24">
								<rect width="24" height="24" fill="none" />
								<path fill="#000" d="M12 0a1 1 0 0 1 1 1v2h5v6h-5v3h5l4 3l-4 3h-5v5a1 1 0 1 1-2 0v-5H6v-6h5V9H6L2 6l4-3h5V1a1 1 0 0 1 1-1" />
							</svg>
						</Typography>
						Street
					</Button>
					<Button
						variant="contained"
						onClick={() => {
							navigate("/", {state: {address: searchedAddress, from: "zipcode"}});
						}}
						fullWidth
						sx={{gap: 1, background: "#F8F9FA", color: "#605F5F", border: "1px solid #d8d6d6"}}>
						<Typography fontWeight={600} sx={{color: "#FFC107", fontSize: 18}}>
							<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 256 256">
								<rect width="256" height="256" fill="none" />
								<path fill="#000" d="M136 127.42V232a8 8 0 0 1-16 0V127.42a56 56 0 1 1 16 0" />
							</svg>
						</Typography>
						Zipcode
					</Button>
				</Stack>
			</div>

			<Footer />
		</div>
	);
};

export default ReviewsListingPage;
